import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { postAccountCreation, getCorporateAllTypesDropdowns } from '../../store/actions/corporateAction';
import { indCreateAccount } from '../../store/actions/individualAction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useEffect } from 'react';
import { setLanguage } from '../../store/slices/contentSlice';
import { languages } from '../../config/config';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();

  const { authLoading, corporate_all_types_dropdowns } = useSelector((state) => state.auth);
  const { authContent, language } = useSelector((state) => state.content);
  // const { is_corporate } = useSelector((state) => state.constant);
  const [searchParams, setSearchParams] = useSearchParams();


  const is_corporate = true;

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_open_new_account?.data?.attributes, key, isArabic);
  };

  useEffect(() => {
    changeLanguage();
  }, [language, searchParams]);

  const changeLanguage = () => {
    const languageId = searchParams.get('languageId');
    dispatch(getCorporateAllTypesDropdowns(languageId ? languageId == 4 : isArabic));

    if (languageId) {
      dispatch(setLanguage({ language: languageId == 3 ? languages?.eng : languages?.arb }))
      setSearchParams({})
    }
  }

  const onSubmit = (values) => {
    const api_data = {
      mobileNumber: values?.phoneNumber,
      languageId: isArabic ? 4 : 3,
      investorTypeId: is_corporate ? 2 : 1,
    };

    if (is_corporate) {
      api_data.applicantTypeId = values?.applicantType?.id;
      // api_data.companyTypeId = corporate_all_types_dropdowns?.companyTypes?.[0]?.id;
      dispatch(postAccountCreation(api_data, navigate));
    } else {
      dispatch(indCreateAccount(api_data, navigate));
    }
  };

  return {
    TextWeight,
    authLoading,
    onSubmit,
    getContentKey,
    corporate_all_types_dropdowns,
    is_corporate,
    navigate,
    isArabic,
  };
};
